import { PaginationInput } from '../common/paginationInput';
import { DealerFilter } from './dealerFilter';

export class DealerInput {
  paginationInput: PaginationInput = new PaginationInput(null, null);
  filter: DealerFilter;
}
